// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#decline-artwork-dropzone[data-v-8c420c60]{min-height:126px}#decline-artwork-add-files[data-v-8c420c60]{padding-top:45px}.dz-uploaded-file[data-v-8c420c60]{cursor:default}", ""]);
// Exports
module.exports = exports;
